'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var silver={1:'#fafafa',2:'#f6f6f6',3:'#ececec',4:'#dadada',5:'#949494',6:'#757575',7:'#646464',8:'#525252',9:'#3c3c3c',10:'#1c1c1c',inflection:6};exports.default=(0,_createColorPalette2.default)(silver,'silver');


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/colors/silver.js
 **/